import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import {  gridDrawerWidth} from 'store/constant';



const ProjectPreviewSidePanel = ({ isProjectSelected, content }) => {
  const theme = useTheme();
  // Media query for tablet devices
  const isMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Box component="nav"  sx={{ flexShrink: { md: 0 }, width: "auto" }} aria-label="mailbox folders">
      <Drawer
        variant={'persistent'}
        anchor="right"
        open={isProjectSelected}
        sx={{
          '& .MuiDrawer-paper': {
            width: isMedium ? "calc(3/5 * 100%)" : '550px',
            background: "#F2EEE3!important",
            color: theme.palette.text.primary,
            borderBottom: 'none',
            borderRight: '3px solid #D8D5CC',
            borderLeft: '3px solid #D8D5CC',
            overflow: "hidden",
            top: '57px',
            // height: "calc(100vh - 10.7rem)",
            [theme.breakpoints.up('md')]: {
              top: '57px',
              width: gridDrawerWidth - 30,
             /*  zIndex: 120, */
              overflow: "hidden",
              /*  zIndex: 1222 */
              /*   zIndex: 1200 */
            },
            [theme.breakpoints.up('lg')]: {
              width: gridDrawerWidth - 30,
            }
          }
        }}
        ModalProps={{ keepMounted: true, hideBackdrop: true, }}
        color="inherit"
      >
        {content}
      </Drawer>
    </Box>
  );
};

ProjectPreviewSidePanel.propTypes = {
  isProjectSelected: PropTypes.bool,
};

export default ProjectPreviewSidePanel;

